import { replaceConfig } from 'common/dynamic-form/utils/formly-configs';

import { TemplateConfig } from './model/template-config.interface';

import { ISPFieldConfig } from '../../model';

/**
 * Separate templates configs to templates that should be added and templates that should replace some other configs
 *
 * @param templates
 */
export function separateTemplatesByInsertingType(
  templates: TemplateConfig[],
): [TemplateConfig[], TemplateConfig[]] {
  return templates.reduce<[TemplateConfig[], TemplateConfig[]]>(
    ([toAdd, toReplace], config) => {
      if (config.props.replace) {
        toReplace.push(config);
      } else {
        toAdd.push(config);
      }
      return [toAdd, toReplace];
    },
    [[], []],
  );
}

/**
 * Replace some configs with templates
 *
 * @param configs
 * @param templates
 */
export function replaceConfigByTemplates(
  configs: ISPFieldConfig[],
  templates: TemplateConfig[],
): void {
  templates.forEach(template => {
    if (template.props.replace) {
      template.props.replacedConfig = replaceConfig(
        configs,
        template,
        template.props.replace,
      );

      // @WARN fieldGroup should not be undefined!
      if (template.props.replacedConfig?.fieldGroup) {
        template.fieldGroup = template.props.replacedConfig.fieldGroup;
      }
    }
  });
}
